import { Button, Card, Chip, Divider, Icons, Stack, Typography } from '@healthinal/ui';
import { useState } from 'react';
import { TherapyDto } from '../../../../../api/generated/model';
import {
  getGetHospitalizationByPatientQueryKey,
  useGetHospitalizationByPatientSuspense,
} from '../../../../../api/generated/patient-controller/patient-controller.ts';
import { formatDateWithGermanMonth } from '../../../../../utils/date.ts';
import { EndPatientAddressDialog } from '../../../../components/patient-address/EndPatientAddressDialog.tsx';
import { PatientAddressDisplay } from '../../../../components/patient-address/PatientAddressDisplay.tsx';
import { CreateHospitalizationDialog } from './CreateHospitalizationDialog.tsx';

export function HospitalizationCard({ patientId, therapy }: { patientId: string; therapy?: TherapyDto }) {
  const { data: hospitalization } = useGetHospitalizationByPatientSuspense(patientId);
  const [isCreateHospitalizationDialogOpen, setIsCreateHospitalizationDialogOpen] = useState(false);
  const [isEndPatientAddressDialogOpen, setIsEndPatientAddressDialogOpen] = useState(false);

  return (
    <>
      <Card>
        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
          <Stack gap={1}>
            <Typography level="title-lg">Hospitalisation</Typography>
            {!hospitalization ? (
              <Chip>Nicht hospitalisiert</Chip>
            ) : (
              <Chip
                color={'success'}
                variant={'solid'}
                endDecorator={<Icons.Edit />}
                onClick={() => setIsEndPatientAddressDialogOpen(true)}>
                Hospitalisiert
              </Chip>
            )}
          </Stack>
          {!therapy?.finished && (
            <Button color={'neutral'} onClick={() => setIsCreateHospitalizationDialogOpen(true)}>
              Hospitalisation erfassen
            </Button>
          )}
        </Stack>
        {hospitalization && <Divider />}
        {hospitalization && (
          <Stack gap={2}>
            <Stack direction={'row'} alignItems={'center'}>
              <Typography flex={1} level={'title-md'}>
                Hospitalisiert
              </Typography>
              <Typography flex={3} level={'title-sm'}>
                {formatDateWithGermanMonth(hospitalization.from)} - {formatDateWithGermanMonth(hospitalization.until) ?? 'Jetzt'}
              </Typography>
            </Stack>
            <Stack direction={'row'}>
              <Typography flex={1} level={'title-md'}>
                Spital
              </Typography>
              <PatientAddressDisplay flex={3} patientAddress={hospitalization} />
            </Stack>
          </Stack>
        )}
      </Card>
      <CreateHospitalizationDialog
        open={isCreateHospitalizationDialogOpen}
        onClose={() => setIsCreateHospitalizationDialogOpen(false)}
        patientId={patientId}
      />
      {hospitalization && (
        <EndPatientAddressDialog
          open={isEndPatientAddressDialogOpen}
          onClose={() => setIsEndPatientAddressDialogOpen(false)}
          patientAddress={hospitalization}
          modalTitle={'Hospitalisation'}
          queryKeyToInvalidate={getGetHospitalizationByPatientQueryKey(patientId)}
        />
      )}
    </>
  );
}
